import CouncilMembership from "../board-memberships/CouncilMembership";

export default function CouncilDetails() {
  return (
    <div>
      <div className="government-bg bg-image">
        <div className="gap-spacer"></div>
        <div className="page-title top-cap-outlines">
          <h2>Borough Council</h2>
        </div>
        <div className="content-fluid">
          <div className="mb-960-center-container mid-side-outlines ">
            <div className="mb-960-col-50p left-side-col-50p">
              <h4>Meetings</h4>
              <ul>
                <li>7:00 p.m.</li>
                <li>3rd Tuesday of the month</li>
                <li>
                  <a href="https://maps.app.goo.gl/RjUcQgXYQvFVtETj8">
                    <i className="fa-solid fa-location-pin"></i>&nbsp;Borough
                    Hall
                    <br />
                    35 Union Street
                    <br />
                    Morrisville, PA 19067
                  </a>
                </li>
              </ul>
              <h4>Composition</h4>
                <ul>
                <li>Elected officials</li>
                  <li>8 Members</li>
                  <li>4 year terms</li>
                  <li>Terms expire on the first Monday in January</li>
                </ul>    
              {/*Accordion Start*/}
              <div className="container accordion-container">
                <div className="accordion" id="councilMtgAccordion">
                  {/* Item Start */}
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button
                        className="accordion-button caret-off collapsed darkblue-item button-full-width"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseMtgAgendaMinutes"
                      >
                        <div>
                          <i
                            className="far fa-file-pdf fa-2xl feature-icon af-icon"
                            
                          ></i>
                        </div>

                        <div>
                          <b>Meeting Agendas and Minutes</b>
                        </div>
                      </button>
                    </h2>
                    <div
                      id="collapseMtgAgendaMinutes"
                      className="accordion-collapse collapse"
                      data-bs-parent="#councilMtgAccordion"
                    >
                      <div className="accordion-body">
                        <p>
                          Agendas will be posted 24 hours prior to a scheduled
                          meeting.
                        </p>
                        <p>
                          Minutes from a meeting will be posted after approval
                          by Borough Council.
                        </p>
                        <p>
                          <a href="../docs">
                            Visit the Document Archive to view all available
                            Agendas &amp; Meeting Minutes&nbsp;
                            <i className="fa-solid fa-link"></i>
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* Item Finish */}
                  {/* Item Start */}
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button
                        className="accordion-button caret-off collapsed darkblue-item button-full-width"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseMeetingVid"
                      >
                        <div>
                          <i
                            className="fa-regular fa-circle-play fa-2xl feature-icon af-icon"></i>
                        </div>

                        <div>
                          <b>Videos and Live Stream Access</b>
                        </div>
                      </button>
                    </h2>
                    <div
                      id="collapseMeetingVid"
                      className="accordion-collapse collapse"
                      data-bs-parent="#councilMtgAccordion"
                    >
                      <div className="accordion-body">
                        <p>
                          <a href="https://stream.lifesizecloud.com/extension/7006865/701aaf40-9042-4e66-adbe-12aeb894b216">
                            While a Council Meeting is in session, a Live Stream
                            can be accessed by clicking on this link&nbsp;
                            <i className="fa-solid fa-video"></i>
                          </a>
                        </p>
                        <p>
                          Videos from past Council Meetings are uploaded to
                          YouTube{" "}
                          <a href="https://www.youtube.com/@morrisvilleborough1962">
                            Morrisville Borough YouTube Channel&nbsp;
                            <i className="fa-solid fa-arrow-up-right-from-square"></i>
                          </a>
                        </p>
                        <p>
                          Videos are also available direct from Borough's cloud
                          server{" "}
                          <a href="https://docs.google.com/document/d/11aV5PeGxlTmS6E6XpvAY8p91WsFav-e0lY1786P_6G4/edit?usp=sharing">
                            Morrisville Borough Cloud Server&nbsp;
                            <i className="fa-solid fa-arrow-up-right-from-square"></i>
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* Item Finish */}
                  {/* Item Start */}
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button
                        className="accordion-button caret-off collapsed darkblue-item button-full-width"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseAgendaConsideration"
                      >
                        <div>
                          <i
                            className="fa-solid fa-gears fa-2xl feature-icon af-icon"
                            
                          ></i>
                        </div>
                        <div>
                          <b>Apply for Agenda Item Consideration</b>
                        </div>
                      </button>
                    </h2>
                    <div
                      id="collapseAgendaConsideration"
                      className="accordion-collapse collapse"
                      data-bs-parent="#councilMtgAccordion"
                    >
                      <div className="accordion-body">
                        <p>
                          To be included on an agenda for consideration, please
                          submit a letter of interest via email to:
                          <br />
                          <center>
                            {" "}
                            <a href="mailto:office@MorrisvilleBoro.org">
                              <i className="fa-solid fa-envelope"></i>
                              &nbsp;office@morrisvilleboro.org
                            </a>
                          </center>{" "}
                          Letters should be sent on or before the 2nd Monday of
                          the month, 8 days prior to the meeting date of that
                          month.
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* Item Finish */}
                  
                </div>
              </div>
            </div>

            <div className="mb-960-col-50p">
              <div className="council-members">
               <CouncilMembership/>
              </div>
            </div>
          </div>
        </div>
        <div className="page-footer bottom-cap-outlines">&nbsp;</div>
        <div className="gap-spacer"></div>
      </div>
    </div>
  );
}
